import { createContext, useContext } from 'react'

import { UserBusinessAccountAssociationStatus } from '~/gql/graphql'

import { BannerSubcategory } from './logic'

interface BannerContextType extends UserBusinessAccountAssociationStatus {
    userEmail: string
    bannerSubcategory: BannerSubcategory
}

/**
 * Will throw an error in the hook if context is null.
 * Will be set in the provider.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const BannerContext = createContext<BannerContextType>(null as any)

export function useBannerContext() {
    const context = useContext(BannerContext)

    if (!context) {
        throw new Error(
            'useBannerContext must be used within a BannerContext.Provider',
        )
    }

    return context
}
